// extracted by mini-css-extract-plugin
export default {"crawlingAnt":"wavyConnectorLine_crawlingAnt__wQoLu","dashMove":"wavyConnectorLine_dashMove__wvCCE"};